// @flow

import { type UserInputValues } from '@tectonics/prs/user-input-values';
import { type OutgoingPayment } from '@tectonics/prs/outgoing-payment/types';

export async function instalmentsOutgoingPaymentMapper(
  userInputValues: UserInputValues,
): Promise<$Shape<OutgoingPayment>> {
  const selectedInstalment = userInputValues['selectedInstalment'];
  const selectedPaymentMethod = userInputValues['selectedPaymentMethod'];

  return {
    instalments: instalmentsAllowedForPaymentMethod(selectedPaymentMethod) ? selectedInstalment : '1',
  };
}

function instalmentsAllowedForPaymentMethod(paymentMethod: string): boolean {
  switch (paymentMethod) {
    case 'creditcard':
    case 'google':
    case 'oneclick':
      return true;
    default:
      return false;
  }
}
